<div class="edit-profile-container m-r-10 m-b-20">
  <div class="accountinfo">
    <fui-heading extraClasses="text-nowrap" [text]="'Profile & Cover Photo'" [level]="5"></fui-heading>
    <div class="cover-photo" [ngStyle]="{ 'background-image': user.cover_photo ? 'url(' + user.cover_photo + ')' : 'url(./assets/images/studio-one-plus-profile-banner.png)' }">
      <div class="profile-photo-container">
        <img [src]="userService.profilePicture" [alt]="'profile.profile_photo_alt' | translate: { name: user.firstName + ' ' + user.lastName }" />
        <div class="edit-buttons d-flex align-items-center justify-content-center">
          <fa-icon icon="pencil" [ngbTooltip]="'Change Profile Photo'" class="circle-icon-btn m-r-5" (click)="showChangeProfilePhoto()" aria-hidden="true"></fa-icon>
          <fa-icon icon="times" [ngbTooltip]="'Remove Profile Photo'" class="circle-icon-btn" (click)="removeProfilePhoto()" aria-hidden="true"></fa-icon>
        </div>
      </div>
      <div class="cover-photo-edit-buttons">
        <fa-icon icon="pencil" [ngbTooltip]="'Change Cover Photo'" class="circle-icon-btn m-r-5" (click)="showChangeCoverPhoto()" aria-hidden="true"></fa-icon>
        <fa-icon icon="times" [ngbTooltip]="'Remove Cover Photo'" class="circle-icon-btn" (click)="removeCoverPhoto()" aria-hidden="true"></fa-icon>
      </div>
    </div>

    <div class="row">
      <div class="col-12 m-t-50">
        <fui-heading [text]="'Member Since'" [level]="5"></fui-heading>
        <p>{{ user.createdTime | date: "MMMM Do, YYYY" }}</p>
      </div>
      <div class="col-12">
        <form id="account_form" class="form-horizontal text-left row m-t-50 m-b-50" name="basic_profile">
          <div class="form-group text-left col-md-12">
            <fui-heading [text]="'account.about' | translate" [level]="5"></fui-heading>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="firstName">{{ "account.first_name" | translate }}*</label>
            <input type="text" class="form-control" name="firstName" id="firstName" [(ngModel)]="user.firstName" [placeholder]="'account.enter_name' | translate" autocomplete="given-name" required />
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="lastName">{{ "account.last_name" | translate }}*</label>
            <input
              type="text"
              class="form-control"
              name="lastName"
              id="lastName"
              [(ngModel)]="user.lastName"
              [placeholder]="'account.enter_last_name' | translate"
              autocomplete="family-name"
              required
            />
          </div>

          <div class="form-group col-md-12">
            <label class="control-label" for="tagline">{{ "account.tagline" | translate }}</label>
            <input type="text" class="form-control" name="tagline" id="tagline" [(ngModel)]="tagline" [placeholder]="'com.100_characters' | translate" aria-describedby="taglineHelp" />
          </div>

          <div class="form-group col-md-12">
            <label class="control-label" for="description">{{ "account.description" | translate }}</label>
            <textarea
              name="description"
              id="description"
              [(ngModel)]="user.description"
              [placeholder]="'account.description_note' | translate"
              class="form-control"
              aria-describedby="descriptionHelp"
              >{{ user.description }}</textarea
            >
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="email">{{ "account.email" | translate }}</label>
            <input
              type="text"
              class="form-control"
              name="email"
              id="email"
              [(ngModel)]="user.email"
              [placeholder]="'account.enter_email' | translate"
              autocomplete="email"
              aria-describedby="emailHelp"
              [disabled]="user.fender_user_details && user.fender_user_details?.provider != 'cognito'"
            />
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="phone">{{ "account.phone" | translate }}</label>
            <input type="phone" [(ngModel)]="user.phone" name="phone" class="form-control" id="phone" [placeholder]="'account.enter_phone' | translate" autocomplete="tel" />
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="native_language">{{ "sphere.account.language" | translate }}</label>
            <select class="form-control" id="native_language" name="native_language" [(ngModel)]="user.native_language" autocomplete="language">
              @for (language of languages; track language) {
                <option [ngValue]="language.code">{{ language.title }}</option>
              }
            </select>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="country">{{ "account.country_region" | translate }}</label>
            <select class="form-control" id="country" name="country" [(ngModel)]="user.country" autocomplete="country-name">
              @for (country of countries; track country) {
                <option [ngValue]="country.code">{{ country.title }}</option>
              }
            </select>
          </div>

          <div class="form-group col-12 col-md-6">
            <label class="control-label" for="birthday">{{ "account.birthday" | translate }}</label>
            <div
              class="form-control pointer"
              tabindex="0"
              (keyup.enter)="showDatePicker()"
              (keydown.space)="showDatePicker(); $event.preventDefault()"
              name="birthday"
              id="birthday"
              (click)="showDatePicker()"
              autocomplete="bday"
              role="button"
            >
              {{ birthday ? (birthday | date) : "None selected." }}
              <fa-icon icon="calendar" class="m-l-5"></fa-icon>
            </div>
          </div>

          <div class="form-group col-md-12 m-y-20">
            <myp-switch [active]="isPublic" [label]="'account.make_profile_public' | translate" [labelToRight]="true" (toggle)="isPublic = !isPublic"></myp-switch>
            <small id="publicCheckHelp" class="pad text-muted">{{ "account.public_profile_description" | translate }}</small>
          </div>

          <div class="col-md-12">
            <button class="btn btn-secondary" (click)="saveAccountInfo()">
              @if (saving) {
                <div role="status">{{ saveButtonText }}</div>
              }
              @if (!saving) {
                <div>
                  <fa-icon icon="check"></fa-icon>
                  &nbsp;{{ "account.save_button" | translate }}
                </div>
              }
            </button>
          </div>
        </form>

        <div class="m-y-50">
          <myp-account-skills></myp-account-skills>
        </div>

        <div class="m-y-50">
          <myp-account-addresses></myp-account-addresses>
        </div>

        <div class="m-y-50">
          <fui-heading text="Account Actions" [level]="5"></fui-heading>
          @if (!user.fender_user_details || user.fender_user_details?.provider == "cognito") {
            <button class="btn btn-secondary btn-sm m-b-10 m-r-5" (click)="openChangePassword()">
              <fa-icon icon="key"></fa-icon>
              {{ "account.change_password" | translate }}
            </button>
          }
          <button class="btn btn-secondary btn-sm m-b-10 m-r-5" (click)="downloadData()">
            <fa-icon icon="download"></fa-icon>
            {{ "account.download_data" | translate }}
          </button>
          <button class="btn btn-secondary btn-sm m-b-10" (click)="deleteData()">
            <fa-icon icon="trash"></fa-icon>
            {{ "account.delete_data" | translate }}
          </button>
        </div>

        <div class="m-y-50">
          <fui-heading text="Login Method" [level]="5"></fui-heading>
          @if (user.fender_user_details?.provider == "cognito") {
            <p>Email & Password</p>
          }
          @if (user.fender_user_details?.provider != "cognito") {
            <div class="d-flex align-items-center m-y-20">
              <myp-svg [id]="user.fender_user_details?.provider + '-logo'" class="svg-neutral" width="20" height="20"></myp-svg>
              <strong class="m-l-5">{{ user.fender_user_details?.provider | sentenceCase }}</strong>
            </div>
          }
          @if (user.fender_user_details?.provider != "cognito") {
            <div class="d-flex align-items-center">
              <button class="btn btn-secondary btn-sm m-r-5" (click)="appService.showModal(newPasswordModalContent)">
                Switch to Email/Password Login
                @if (removingSocialLogin) {
                  <fa-icon icon="spinner" class="m-l-5" animation="spin"></fa-icon>
                }
              </button>
              <fa-icon
                icon="question-circle"
                class="m-l-5"
                placement="top"
                [ngbTooltip]="
                  'Want to log in with an email and password instead? Set your password here. This can help if you\'re trying to log into Universal Control or PreSonus Hub, or if you\'re deleting your social account and want to unlink it.'
                "
              ></fa-icon>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #captchaModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="hardware-history-details">{{ "account.verify_human" | translate }}</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="captcha d-flex justify-content-center">
      <re-captcha (resolved)="resolved($event)" siteKey="{{ env.reCaptchaKey }}"></re-captcha>
    </div>
  </div>
</ng-template>

<ng-template #newPasswordModalContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-password-update">Add Password to Account</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="control-label">
        Enter the password you'd like to use when logging into this account with your email ({{ user.email }}). This will remove your ability to log in with your
        {{ user.fender_user_details?.provider | sentenceCase }} account, and you will only be able to log in with your email and the password you enter below. You can always change your password in
        the future on this page.
      </label>
      <div class="password-input">
        <input type="text" id="password" [(ngModel)]="newPassword" class="form-control" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="removeSocialLogin()">Submit</button>
  </div>
</ng-template>
